<template>
  <div class="maoindex">
    <div @click="attention()">关注公众号</div>
    <div v-show="showbkpage">
      <img class="top_bk_img" :src="img.bkimg">
      <div class="bk_contant">
        <div class="miao_text">喵~</div>
        <div class="welcome_text">
          <div>欢迎您来凌志范儿小程序，您是第98位受邀车主，</div>
          <div>这里将给您提供......</div>
        </div>
        <div class="tips_text">温馨提醒：当前邀请码为定向车主，只有您可以使用。</div>
        <div class="mao_img_box">
          <img class="mao_img" :src="img.maoimg">
          <img @click="showPoppage()" class="top_pop" :src="img.toppop">
          <img @click="showPoppage()" class="left_pop" :src="img.leftpop">
          <img @click="showPoppage()" class="right_pop" :src="img.rightpop">
        </div>
        <div class="save_img_box">
          <img @click="goMotor()" class="save_img" :src="img.saveimg">
        </div>
      </div>
    </div>
    <div class="pop_bk_box" @click="showbkpage=true" v-show="!showbkpage">
      <div class="pop_bk_content">
        <div class="pop_bk_title_box">
          <img class="pop_icon" :src="img.pop_icon">
          <div class="pop_bk_title">活动权益</div>
          <img class="pop_icon" :src="img.pop_icon">
        </div>
        <div class="pop_username">Andy</div>
        <div class="pop_text">您好，您查看的活动权益共有<span class="pop_num">3</span>项</div>
        <div class="pop_top_box">
          <div>品牌活动邀请</div>
        </div>
        <div class="pop_left_box">
          <div>专享多种</div>
          <div>活动邀请特权</div>
        </div>
        <div class="pop_right_box">
          <div>范儿专属客服</div>
          <div class="pop_right_box_text"><img class="pop_icon" style="margin-right: 5px;" :src="img.pop_icon">范儿专属客服</div>
          <div class="pop_right_box_text"><img class="pop_icon" style="margin-right: 5px;" :src="img.pop_icon">范儿专属客服</div>
          <div class="pop_right_box_text"><img class="pop_icon" style="margin-right: 5px;" :src="img.pop_icon">范儿专属客服</div>
        </div>
      </div>
      <img class="top_bk_img" :src="img.popbk">
    </div>
    <!-- {{userinfo.name}} -->

  </div>
</template>

<script>
  import common from '../../../api/common';
  import content from '../../../api/content';
  import wxShare from '../../../api/wxShare';
  import member from '../../../api/member/memberinfo';
  import { mapState } from 'vuex';
  export default {
    data () {
      return {
        scene:0,
        showbkpage:true,
        img:{
          bkimg: require('../../../assets/img/mao/bkimg.png'),
          maoimg: require('../../../assets/img/mao/maoimg.png'),
          leftpop: require('../../../assets/img/mao/leftpop.png'),
          toppop: require('../../../assets/img/mao/toppop.png'),
          rightpop: require('../../../assets/img/mao/rightpop.png'),
          saveimg: require('../../../assets/img/mao/saveimg.png'),
          popbk: require('../../../assets/img/mao/popbk.png'),
          pop_icon: require('../../../assets/img/mao/pop_icon.png'),
        }
      }
    },
    computed: {
      ...mapState({
        user: state => state.param.user,
        source: state => state.param.source
      })
    },
    created () {
      if(this.$route.query.token){
        this.source = this.$route.query.source
        this.token = this.$route.query.token
        this.user_id = this.$route.query.userid
        this.getUserInfo(this.$route.query.userid)
      }

      var params={
        event_code: '折纸猫落地页',
        event_id: '',
        title: '',
        value: '',
        path: '/maoindex',
        user_id: '',
        source: this.source,
        source_page: '折纸猫落地页'
      }
      this.toBurialPoint(params)
     //  var dataForWeixin= {
     //    title:'凌志范儿拍了拍你，邀请你加入',
     //    description:'关注齐我们的4个账号，100%有好礼相送',
     //    url:'https://m.motortime.com/redblogger',
     //    pic_url:'https://pic.motortime.com/Uploadfile/Picture/90/2c/902c7ddecf93bc71ba6940f841993656.jpg'
     //  }
     //  content.getShare({url:'https://m.motortime.com/redblogger'}).then(res => {
     //    if(res.data.state == 1) {
     //     wxShare.getJSSDK(res.data.data, dataForWeixin)
     //   }
     // })
   },
   methods: {
    getUserInfo(id){
      var params={
        user_id:parseInt([id]),
        source:this.source
      }
      member.userOther(params).then(res => {
        if(res.data.state==1){
          this.userinfo=res.data.data
        }
      })
    },
    showPoppage(){
      this.showbkpage=false
    },
    toBurialPoint (params) {
      common.BurialPoint(params).then(res => {
        if(res.data.state == 1) {
          console.log('埋点成功')
        }
      })
    },
    goMotor(){
      window.open('https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=Mzg4NDg5MDg4MQo=#wechat_redirect')
      // wx.miniProgram.redirectTo({url:'/pages/approve/approve'})
    },
    attention(){
      window.open('https://mp.weixin.qq.com/mp/profile_ext?action=home&__biz=Mzg4NDg5MDg4MQo=#wechat_redirect')
    }
  }
};
</script>

<style lang="scss">
  .maoindex {
    position: relative;
    -moz-user-select:none; /* Firefox私有属性 */
    -webkit-user-select:none; /* WebKit内核私有属性 */
    -ms-user-select:none; /* IE私有属性(IE10及以后) */
    -khtml-user-select:none; /* KHTML内核私有属性 */
    -o-user-select:none; /* Opera私有属性 */
    user-select:none;
    // overflow-x: hidden;
    .top_bk_img{
      width: 100%;
      position: absolute;
      top: 0;
      z-index: 1;
    }
    .bk_contant{
      width: 100%;
      position:absolute;
      z-index: 2;
      top: 5%;
      text-align: center;
    }

    .bk_img{
      width: 100%;
      height: 100%;
      background-size:cover;
      text-align: center;
      background-position:bottom;
      background-attachment:scroll;
    }
    .miao_text{
      margin-top: 15%;
      font-size: 26px;
      font-weight: bold;
      
    }
    .welcome_text{
      font-size: 14px;
      font-weight: bold;
      margin-top: 20px;
      line-height: 20px;
    }
    .tips_text{
      font-size: 12px;
      margin-top: 20px;
    }
    .mao_img_box{

      position:relative;
      margin-top: 10%;
    }
    .mao_img{
      width: 100%;
      object-fit: cover;
    }
    .save_img_box{
      width: 100%;
      // position:fixed;
      // bottom:5%;
    }
    .save_img{
      width: 110px;
      height: 50px;
      margin-top: -20px;
    }
    .top_pop{
      position:absolute;
      top: 7%;
      right: 11%;
      width: 110px;
    }
    .left_pop{
      position:absolute;
      top: 22%;
      left: 6%;
      width: 110px;
    }
    .right_pop{
      position:absolute;
      top: 31%;
      right: 4%;
      width: 110px;
    }
    .pop_bk_box{
      width: 100%;
      // height: 100vh;
      // overflow-y: hidden;
      // overflow-x: hidden;
      position:relative;
    }
    .pop_bk_content{
      position:absolute;
      z-index: 2;
      top: 0;
      left: 0;
      right: 0;
      text-align: center;
    }
    .pop_bk_title_box{
      margin-top: 45%;
      display: flex;
      align-items:center;
      justify-content: center;
    }
    .pop_bk_title{
      color: #717D64;
      font-size: 15px;
      margin: 0 10px;
      font-weight: bold;
      letter-spacing:2px;
    }
    .pop_icon{
      width: 7px;
      height: 7px;
    }
    .pop_username{
      margin-top: 15px;
      font-size: 23px;
      font-weight: bold;
    }
    .pop_text{
      font-size: 15px;
      margin-top: -15px;
    }
    .pop_num{
      color: #FFCE65;
      font-size: 38px;
      font-weight: bold;
      margin: 0 5px;
    }
    .pop_top_box{
      color: #717D64;
      font-size: 12px;
      text-align: center;
      margin-top: 22%;
      margin-left: 36%;
    }
    .pop_left_box{
      color: #717D64;
      font-size: 12px;
      text-align: center;
      margin-top: 4%;
      margin-right: 53%;
    }
    .pop_right_box{
      color: #717D64;
      font-size: 12px;
      text-align: center;
      margin-top: 32%;
      margin-left: 55%;
    }
    .pop_right_box_text{
      display: flex;
      align-items:center;
      justify-content: center;
    }


  }
</style>
